import { render, staticRenderFns } from "./Blanks.vue?vue&type=template&id=6565c11f&scoped=true&"
import script from "./Blanks.vue?vue&type=script&lang=js&"
export * from "./Blanks.vue?vue&type=script&lang=js&"
import style0 from "./Blanks.vue?vue&type=style&index=0&id=6565c11f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6565c11f",
  null
  
)

export default component.exports